const eurFormatter = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
});

export function formatCurrency (value?: number | null): string {
  if (value == null || isNaN(value)) return eurFormatter.format(0);
  return eurFormatter.format(value);
}
